import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../utils/api";

// New-admission counts, this academic year vs the previous one, month by
// month — shared between the admin and principal dashboards.
const StudentGrowthWidget = () => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/reports/student-growth`)
      .then((res) => setReport(res.data))
      .catch(() => setReport(null))
      .finally(() => setLoading(false));
  }, []);

  const data = report?.data || [];
  const maxValue = Math.max(1, ...data.map((d) => Math.max(d.current, d.previous)));
  const change = report?.summary?.changePercent;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="text-lg font-semibold text-gray-800">📈 Students Joined: This Year vs Last Year</h3>
        {report && (
          <div className="flex items-center gap-4 text-sm">
            <span className="text-blue-700 font-medium">{report.currentYearLabel}: {report.summary.currentTotal}</span>
            <span className="text-gray-500 font-medium">{report.previousYearLabel}: {report.summary.previousTotal}</span>
            {change !== null && change !== undefined && (
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${change >= 0 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                {change >= 0 ? "▲" : "▼"} {Math.abs(change)}%
              </span>
            )}
          </div>
        )}
      </div>

      {loading ? (
        <p className="text-sm text-gray-400 text-center py-8">Loading…</p>
      ) : !report || data.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-8">No admission data available.</p>
      ) : (
        <>
          <div className="flex items-end gap-2 h-40 border-b border-gray-200 pb-1">
            {data.map((d) => (
              <div key={d.month} className="flex flex-col items-center gap-1 flex-1 h-full justify-end">
                <div className="flex items-end gap-0.5 h-full">
                  <div
                    className="w-3 bg-gray-300 rounded-t"
                    style={{ height: `${Math.max((d.previous / maxValue) * 100, d.previous > 0 ? 2 : 0)}%` }}
                    title={`${report.previousYearLabel}: ${d.previous}`}
                  />
                  <div
                    className="w-3 bg-blue-500 rounded-t"
                    style={{ height: `${Math.max((d.current / maxValue) * 100, d.current > 0 ? 2 : 0)}%` }}
                    title={`${report.currentYearLabel}: ${d.current}`}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-2">
            {data.map((d) => (
              <span key={d.month} className="flex-1 text-center text-xs text-gray-500 pt-1">{d.month}</span>
            ))}
          </div>
          <div className="flex gap-4 mt-3 text-xs text-gray-600">
            <span className="flex items-center gap-1"><span className="w-3 h-3 bg-gray-300 rounded inline-block" /> {report.previousYearLabel}</span>
            <span className="flex items-center gap-1"><span className="w-3 h-3 bg-blue-500 rounded inline-block" /> {report.currentYearLabel}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default StudentGrowthWidget;
